var $39d81641bfeda51f$exports = {};
$39d81641bfeda51f$exports = {
    "removeButtonLabel": `Poista`,
    "removeDescription": `Poista tunniste painamalla Poista-painiketta.`
};


export {$39d81641bfeda51f$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
